import { Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import {
  WebSocketConnected,
  WebSocketDisconnected,
  WebSocketMessageReceived,
  WebSocketError,
} from '../state/websocket.actions';
import { WebSocketStateModel } from '../state/websocket.state';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WebSocketService {
  private socket: WebSocket | null = null;

  connect(ctx: StateContext<WebSocketStateModel>): void {
    if (this.socket) {
      this.socket.close();
    }

    this.socket = new WebSocket(environment.wsUrl);

    this.socket.onopen = () => {
      console.log('[WS] Connected');
      ctx.dispatch(new WebSocketConnected());
    };

    this.socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('[WS] Message:', data);
        ctx.dispatch(new WebSocketMessageReceived(data));
      } catch {
        console.warn('[WS] Non-JSON message:', event.data);
      }
    };

    this.socket.onclose = () => {
      console.log('[WS] Disconnected');
      ctx.dispatch(new WebSocketDisconnected());
    };

    this.socket.onerror = (error) => {
      console.error('[WS] Error:', error);
      ctx.dispatch(new WebSocketError(`WebSocket connection failed (${environment.wsUrl})`));
    };
  }

  disconnect(): void {
    this.socket?.close();
    this.socket = null;
  }

  send(message: { type: string; payload: unknown }): void {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    }
  }
}
